import { PropsWithChildren } from "react";
import InfoMessage from "../InfoMessage";
import { useFormContext } from "react-hook-form";
import ErrorMessage from "../../forms/errors/ErrorMessage";

export type EditorInputProps = {
  name: string;
  inputTitle: string;
  required?: boolean;
  details?: string;
};

const EditorInput = ({
  name,
  inputTitle,
  details,
  required,
  children
}: PropsWithChildren<EditorInputProps>) => {
  const {
    formState: { errors },
    clearErrors
  } = useFormContext();

  const fieldErrors = errors[name];

  return (
    <article className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <h2 className="text-xl">
          {inputTitle} {required && <span className="text-black">*</span>}
        </h2>
        {fieldErrors && (
          <ErrorMessage
            message="Please fill in the required fields marked *"
            clearError={() => clearErrors(name)}
            className="!w-fit"
          />
        )}
      </div>

      {details && <p className=" text-sm text-gray-600">{details}</p>}

      {children}
    </article>
  );
};

export default EditorInput;
